module.exports = __webpack_public_path__ + "static/work_icon_engineering-77658778beb937dd307e06ab4aa64e0b.png";